import React from "react";
import { Briefcase } from "../briefcase";

/**
 * Componente para mostrar el segundo nivel de Nuestro Trabajo. Para la visualización desktop se cargan a través
 * de iteraciones dentro de un carousel, pero para la visualización mobile estas se cargan a 
 * través de iteraciones de forma vertical tomando la información desde el archivo
 *  .src/data/data.json -> "Briefcase"
 *
 * @component
 * @example
 * 
 * "Briefcase": [
    {
      "id": 1,
      "img": "/img/briefcase/Portafolio1.webp",
      "video": "/video/portafolio/video1.mp4",
      "alt": "Snackeros",
      "text": "Una plataforma digital creada para disfrutar de la comida sin reglas",
      "url": "/nuestrotrabajo/portafolio",
      "reto": "Invitar a los ecuatorianos a romper con lo establecido al momento de comer, creando contenido original no publicitario.",
      "insight": "Llevamos años condicionando la forma en que comemos; cocinamos los mismos platos y los consumimos de manera convencional.",
      "idea": "Creamos <b>“Snackeros”</b>, la primera plataforma transmedia donde rompimos las reglas culinarias, mostrando la forma más auténtica de disfrutar la comida.",
      "resultados": "Demostramos que generar contenido de valor puede superar los resultados de publicidad tradicional, logrando conectar con la audiencia de manera innovadora. <br><br> <b>Sobrepasamos la participación digital en un 115%</b>, aumentando el nivel de ventas significativamente. <b>Pasamos del top 10 al top 5 de marcas más preferidas</b> en la categoría de bebidas no alcohólicas.",
      "ejecucion": "",
      "text2": ""
    }
  ]
 */

export const BriefcaseHome = (props) => {
  
  return (
    <div id="briefcase-home" className="text-center">
        <div className="container">
            <div className="col-md-8 col-md-offset-2 section-title">
                <h2><span className="title">Nuestro Trabajo</span></h2>
            </div>
        </div>
      <Briefcase data={props.data} home={true} />
    </div>
  );
};
